module.exports = __webpack_public_path__ + "static/media/checkbox_on.f7b14e0f.svg";